import { RESET_ALL_ACCOUNT_STATE_DEPEN } from "../actions/commonActions";
import { FETCH_KEY_CONVERSATION_FAILURE, FETCH_KEY_CONVERSATION_REQUEST, FETCH_KEY_CONVERSATION_SUCCESS } from "../actions/keyConversationActions";

  const initialState = {
    response: [],
    loading: true,
    error: null,
  };
  
  const keyConversationReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_KEY_CONVERSATION_REQUEST:
        return { ...state, loading: true , payload: action.payload};
      case FETCH_KEY_CONVERSATION_SUCCESS:
        return { ...state, loading: false, response: action.payload };
      case FETCH_KEY_CONVERSATION_FAILURE:
        return { ...state, loading: false, error: action.payload };
      case RESET_ALL_ACCOUNT_STATE_DEPEN:
        return { ...state, loading: false,  response: [] }; 
      default:
        return state;
    }
  };
  
  export default keyConversationReducer;
  